<template>
  <footer class="footer noPrint">
    <div class="firstRow row">
      <div class="col-sm-12">
        <div class="container">
          <div class="row">
            <div class="col-sm-12 text-center">
              <div style="height: 72px">&nbsp;</div>
              <!--img src="@/assets/images/eu-logos.png" alt="ESS" class="img-fluid mt-2 mb-1" style="max-height: 60px" /-->
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="secondRow row">
      <div class="col-sm-12">
        <div class="container">
          <div class="row">
            <div class="col-sm-6 text-left mt-0"><a href="#">© VSRS <span>2020</span></a>
            </div>
              <div class="col-sm-6 text-right mt-0">
                <span v-if="getVersion().includes('SNAPSHOT')" class="badge-info pt-1 pb-1 pl-2 pr-2">Verzija: <b>{{version}}</b></span>
                <span v-else class="pt-1 pb-1 pl-2 pr-2">Verzija: <b>{{version}}</b></span>
              </div>
          </div>
        </div>
      </div>
    </div>
  </footer>
</template>


<script>
    //import Vue from 'vue';
    import {version} from '../../package';

    export default {
        name: 'Footer',
        data() {
            return {
                version: null
            };
        },
        mounted() {
            this.version = this.getVersion()
        },
        methods: {


            getVersion() {
                return version;
            }

        },
    };
</script>
